import { get } from 'lodash';
import styled from 'styled-components';
import {
  allMatrixLevels,
  MatrixMattersByBucket,
} from '../../../../../../../../common/model/output/materiality/materiality-matrix/types';
import { getMatterBucketId } from '../../../../../../../../common/model/output/materiality/materiality-matrix/utils';
import { Axes } from './axes';
import { MatterBox } from './matter-box';
import { SustainabilityMatterId } from '@upright/common/model/input/materiality-assessment/types-matters';
import { MaterialityType } from '@upright/common/model/input/materiality-assessment/types';

/**
 * Draws the matrix boxes and axes
 */
export function MaterialityMatrixArea(props: {
  matters: MatrixMattersByBucket;
  getSingleMatterViewUrl?: (matterId: SustainabilityMatterId, materialityType: MaterialityType) => string;
}) {
  return (
    <Root>
      <Axes />
      {allMatrixLevels.map(imLevel => {
        return allMatrixLevels.map(fmLevel => {
          const matters = get(props.matters, getMatterBucketId(imLevel, fmLevel), []);
          return (
            <MatterBox
              key={`im-${imLevel}:fm-${fmLevel}`}
              imLevel={imLevel}
              fmLevel={fmLevel}
              matters={matters}
              getSingleMatterViewUrl={props.getSingleMatterViewUrl}
            />
          );
        });
      })}
    </Root>
  );
}

/**
 * Splits the drawing area into axes and 3x3 grid
 */
const Root = styled.div`
  display: grid;
  border: 1px;
  grid-template-columns: [y-label] 40px [y-bucket-labels] 35px [x-low] 1fr [x-medium] 1fr [x-high] 1fr;
  grid-template-rows: [y-high] min-content [y-medium] min-content [y-low] min-content [x-bucket-labels] 35px [x-label] 40px;
  grid-template-areas:
    'side matrix matrix matrix'
    'side matrix matrix matrix'
    'side matrix matrix matrix'
    '. bottom bottom bottom';
`;
